// attempting to bring back ducks (see: https://github.com/erikras/ducks-modular-redux)
import { combineActions, createAction, handleActions } from 'redux-actions';

// actions
const CLEAR_ARCHIVED_CONTENT = 'reports/CLEAR_ARCHIVED_CONTENT';
const CLEAR_PUBLISHED_PAGES = 'reports/CLEAR_PUBLISHED_PAGES';
const GET_ARCHIVED_CONTENT_FULFILLED = 'reports/GET_ARCHIVED_CONTENT_FULFILLED';
const GET_ARCHIVED_CONTENT_REJECTED = 'reports/GET_ARCHIVED_CONTENT_REJECTED';
const GET_ARCHIVED_CONTENT_REQUESTED = 'reports/GET_ARCHIVED_CONTENT_REQUESTED';
const GET_CONTENT_BY_LINKS_FULFILLED = 'reports/GET_CONTENT_BY_LINKS_FULFILLED';
const GET_CONTENT_BY_LINKS_REJECTED = 'reports/GET_CONTENT_BY_LINKS_REJECTED';
const GET_CONTENT_BY_LINKS_REQUESTED = 'reports/GET_CONTENT_BY_LINKS_REQUESTED';
const GET_PUBLISHED_PAGES_FULFILLED = 'reports/GET_PUBLISHED_PAGES_FULFILLED';
const GET_PUBLISHED_PAGES_REJECTED = 'reports/GET_PUBLISHED_PAGES_REJECTED';
const GET_PUBLISHED_PAGES_REQUESTED = 'reports/GET_PUBLISHED_PAGES_REQUESTED';
const RESTORE_CONTENT_FULFILLED = 'reports/RESTORE_CONTENT_FULFILLED';
const RESTORE_CONTENT_REJECTED = 'reports/RESTORE_CONTENT_REJECTED';
const RESTORE_CONTENT_REQUESTED = 'reports/RESTORE_CONTENT_REQUESTED';

// action creators
export const clearArchivedContent = createAction(CLEAR_ARCHIVED_CONTENT);
export const clearPublishedPages = createAction(CLEAR_PUBLISHED_PAGES);
export const getArchivedContentFulfilled = createAction(GET_ARCHIVED_CONTENT_FULFILLED);
export const getArchivedContentRejected = createAction(GET_ARCHIVED_CONTENT_REJECTED);
export const getArchivedContentRequested = createAction(GET_ARCHIVED_CONTENT_REQUESTED);
export const getContentByLinksFulfilled = createAction(GET_CONTENT_BY_LINKS_FULFILLED);
export const getContentByLinksRejected = createAction(GET_CONTENT_BY_LINKS_REJECTED);
export const getContentByLinksRequested = createAction(GET_CONTENT_BY_LINKS_REQUESTED);
export const getPublishedPagesFulfilled = createAction(GET_PUBLISHED_PAGES_FULFILLED);
export const getPublishedPagesRejected = createAction(GET_PUBLISHED_PAGES_REJECTED);
export const getPublishedPagesRequested = createAction(GET_PUBLISHED_PAGES_REQUESTED);
export const restoreContentFulfilled = createAction(RESTORE_CONTENT_FULFILLED);
export const restoreContentRejected = createAction(RESTORE_CONTENT_REJECTED);
export const restoreContentRequested = createAction(RESTORE_CONTENT_REQUESTED);

// default state
export const DEFAULT_STATE = {
  archivedContent: [],
  contentByLinks: {},
  isFetching: false,
  publishedPages: [],
  restoredContent: {}
};

// set `isFetching` to true
const requestActions = combineActions(
  GET_ARCHIVED_CONTENT_REQUESTED,
  GET_CONTENT_BY_LINKS_REQUESTED,
  GET_PUBLISHED_PAGES_REQUESTED,
  RESTORE_CONTENT_REQUESTED
);

// set `error` with error message
const errorActions = combineActions(
  GET_ARCHIVED_CONTENT_REJECTED,
  GET_CONTENT_BY_LINKS_REJECTED,
  GET_PUBLISHED_PAGES_REJECTED,
  RESTORE_CONTENT_REJECTED
);

// reducer
export default handleActions(
  {
    [clearArchivedContent]: state => ({ ...state, archivedContent: [] }),
    [clearPublishedPages]: state => ({ ...state, publishedPages: [] }),
    [errorActions]: (state, { payload }) => ({ ...state, error: payload.message }),
    [getArchivedContentFulfilled]: (state, { payload }) => ({
      ...state,
      archivedContent: payload,
      error: undefined,
      isFetching: false
    }),
    [getContentByLinksFulfilled]: (state, { payload }) => ({
      ...state,
      contentByLinks: payload,
      error: undefined,
      isFetching: false
    }),
    [getPublishedPagesFulfilled]: (state, { payload }) => ({
      ...state,
      publishedPages: payload,
      error: undefined,
      isFetching: false
    }),
    [restoreContentFulfilled]: (state, { payload }) => ({
      ...state,
      restoredContent: payload,
      error: undefined,
      isFetching: false
    }),
    [requestActions]: state => ({ ...state, isFetching: true })
  },
  DEFAULT_STATE
);
